import React, { useContext } from 'react';
import { isEmpty } from 'lodash/lang';

import { getItemGroupType } from '../ReviewContent/reviewContentService';
import { ReviewContext } from '../ReviewContext';
import {
  itemGroupSnapshotReviewStateHasRecordsOrNotPerformed,
  logSnapshotReviewStateHasRecords
} from '../reviewService';

import ReviewSidebarItem from './ReviewSidebarItem/ReviewSidebarItem';
import * as logCheckStatusService from './logCheckStatusService';
import * as logStatusService from './logStatusService';
import * as procedureLikeService from './procedureLikeStatusService';

import './ReviewSideBar.scss';

export function ReviewSideBar() {
  const {
    itemGroups,
    logItemGroups,
    logCheckItemGroups,
    setChosenItem,
    itemGroupSnapshotReviewStates,
    logSnapshotReviewStates,
    logCheckSnapshotReviewStates
  } = useContext(ReviewContext);

  return (
    <div className="eds-review-sidebar">
      {!isEmpty(itemGroups) && (
        <div className="eds-review-sidebar-list">
          <h4>Encounter Items</h4>
          <div className="eds-review-sidebar-items">
            {itemGroups.map(item => {
              const itemGroupSnapshotReviewState = itemGroupSnapshotReviewStates[item.patientItemGroupId];
              return (
                <ReviewSidebarItem
                  onClick={() => setChosenItem(item.patientItemGroupId)}
                  hasRecords={itemGroupSnapshotReviewStateHasRecordsOrNotPerformed(itemGroupSnapshotReviewState)}
                  key={item.patientItemGroupId}
                  name={item.patientItemGroupName}
                  loading={!itemGroupSnapshotReviewState}
                  type={getItemGroupType(item)}
                  itemGroupSnapshotReviewState={itemGroupSnapshotReviewState}
                  isNotPerformed={procedureLikeService.isNotPerformed(itemGroupSnapshotReviewStates, item)}
                  isDisabled={procedureLikeService.isDisabled(itemGroupSnapshotReviewStates, item)}
                />
              );
            })}
          </div>
        </div>
      )}
      {!isEmpty(logCheckItemGroups) && (
        <div className="eds-review-sidebar-list">
          <h4>Log Checks</h4>
          <div className="eds-review-sidebar-items">
            {logCheckItemGroups.map(item => {
              const logCheckSnapshotReviewState = logCheckSnapshotReviewStates[item.itemGroupTemplateId];
              return (
                <ReviewSidebarItem
                  onClick={() => {
                    setChosenItem(item.itemGroupTemplateId);
                  }}
                  key={item.itemGroupTemplateId}
                  item={item}
                  name={item.patientItemGroupName}
                  loading={!logCheckSnapshotReviewState}
                  logCheckSnapshotReviewState={logCheckSnapshotReviewState}
                  type="LogChecks"
                  isNotPerformed={logCheckStatusService.isNotPerformed(logCheckSnapshotReviewState)} // NP status check it for logcheck
                  isDisabled={logCheckStatusService.isDisabled(logCheckSnapshotReviewState)}
                />
              );
            })}
          </div>
        </div>
      )}
      {!isEmpty(logItemGroups) && (
        <div className="eds-review-sidebar-list">
          <h4>Log Entries</h4>
          <div className="eds-review-sidebar-items">
            {logItemGroups.map(item => {
              const logSnapshotReviewState = logSnapshotReviewStates[item.itemGroupTemplateId];
              return (
                <ReviewSidebarItem
                  onClick={() => {
                    setChosenItem(item.itemGroupTemplateId);
                  }}
                  hasRecords={logSnapshotReviewStateHasRecords(logSnapshotReviewState)}
                  key={item.itemGroupTemplateId}
                  name={item.name}
                  loading={!logSnapshotReviewState}
                  type="Logs"
                  item={item}
                  isNotPerformed={logStatusService.isNotPerformed(logSnapshotReviewStates, item)}
                  isDisabled={logStatusService.isDisabled(logSnapshotReviewStates, item)}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
